import React from 'react';
export function HowItWorks() {
  const days = [{
    day: 'Día 1',
    title: 'Drenaje',
    desc: 'Vaciamos el exceso de líquido y reseteamos los minerales.'
  }, {
    day: 'Día 2',
    title: 'Restauración',
    desc: 'Sellamos la barrera intestinal para eliminar gases y presión.'
  }, {
    day: 'Día 3',
    title: 'Blindaje',
    desc: 'Estabilizamos las hormonas para evitar el efecto rebote.'
  }];
  return <section className="bg-cream py-24 px-4" data-id="element-75">
      <div className="max-w-5xl mx-auto" data-id="element-76">
        <div className="text-center mb-16" data-id="element-77">
          <h2 className="text-3xl md:text-4xl text-near-black mb-4" data-id="element-78">
            Tu viaje de 72 horas
          </h2>
          <p className="text-lg font-sans text-gray-600" data-id="element-79">
            Un proceso estructurado, claro y sin complicaciones.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-80">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-px bg-sage/50 -z-10 transform -translate-y-1/2" data-id="element-81"></div>

          {days.map((item, index) => <div key={index} className="bg-white p-8 text-center shadow-sm border border-sage/20 relative z-10" data-id="element-82">
              <div className="w-16 h-16 mx-auto bg-sage/20 rounded-full flex items-center justify-center mb-6" data-id="element-83">
                <span className="font-serif text-xl text-dark-green" data-id="element-84">
                  {index + 1}
                </span>
              </div>
              <span className="font-sans text-sm font-semibold text-sage tracking-widest uppercase mb-2 block" data-id="element-85">
                {item.day}
              </span>
              <h3 className="text-2xl font-serif text-near-black mb-4" data-id="element-86">
                {item.title}
              </h3>
              <p className="font-sans text-gray-600" data-id="element-87">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}